var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "selectSource"
  }, [_c('i', {
    staticClass: "arrow-icon",
    class: [_vm.visibleStatus ? 'el-icon-arrow-up' : 'el-icon-arrow-top'],
    attrs: {
      "disabled": _vm.currentItem.status == 0 || _vm.timeLockPage && _vm.timeLocked || _vm.disabled
    },
    on: {
      "click": function ($event) {
        return _vm.changeIconStatus('handle');
      }
    }
  }), _c('el-select', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.scrollData,
      expression: "scrollData"
    }, {
      name: "no-emoji",
      rawName: "v-no-emoji"
    }],
    ref: "selectFocus",
    class: [_vm.valueModel != '' || _vm.isPlace ? 'colorLive' : 'colorOnline'],
    attrs: {
      "filterable": "",
      "placeholder": _vm.deviceType.toLowerCase() == 'r' ? _vm.sourceItem.lastLiveName || _vm.$t('lang.EnterSourceNamePeerID') : _vm.sourceItem.lastLiveName || _vm.$t('lang.home_EnterReceiverNamePeerID'),
      "no-match-text": _vm.$t('lang.NoResult'),
      "remote": "",
      "remote-method": _vm.getData,
      "popper-append-to-body": true,
      "popper-class": "selectSourceNav",
      "disabled": _vm.currentItem.status == 0 || _vm.timeLockPage && _vm.timeLocked || _vm.disabled,
      "value-key": "peerId"
    },
    on: {
      "change": _vm.sendInfo,
      "visible-change": _vm.changeIconStatus
    },
    model: {
      value: _vm.valueModel,
      callback: function ($$v) {
        _vm.valueModel = $$v;
      },
      expression: "valueModel"
    }
  }, _vm._l(_vm.allData, function (item) {
    return _c('el-option', {
      key: item.peerId,
      staticClass: "textLeft",
      class: {
        'gray': item.status == 0,
        'red': item.status == 2
      },
      attrs: {
        "value": item,
        "label": item.name,
        "disabled": item.status == 0,
        "title": item.name + '(' + item.peerId + ')'
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _c('i', {
      staticClass: "iconfont i-eyeView-show check",
      class: _vm.checkIsCheck(item)
    })]);
  }), 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }